import secureLocalStorage from "react-secure-storage";

        const settings = secureLocalStorage.getItem("systemSettings");
        let mainBackground = "#000";

        try {
    const settingsInfo = JSON.parse(settings);
   mainBackground = settingsInfo?.mainBackground || "#000";
  } catch {}

      const icons = {
    ProgramIcon: () => (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <g clipPath="url(#clip0_220_852)">
          <path
            d="M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.375 9C6.99632 9 7.5 8.49632 7.5 7.875C7.5 7.25368 6.99632 6.75 6.375 6.75C5.75368 6.75 5.25 7.25368 5.25 7.875C5.25 8.49632 5.75368 9 6.375 9Z"
            fill={mainBackground}
          />
          <path
            d="M10.125 9C10.7463 9 11.25 8.49632 11.25 7.875C11.25 7.25368 10.7463 6.75 10.125 6.75C9.50368 6.75 9 7.25368 9 7.875C9 8.49632 9.50368 9 10.125 9Z"
            fill={mainBackground}
          />
        </g>
        <defs>
          <clipPath id="clip0_220_852">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),

    ProjectIcon: () => (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_220_1004)">
          <path
            d="M5.25 9.75H2.25C1.83579 9.75 1.5 10.0858 1.5 10.5V13.5C1.5 13.9142 1.83579 14.25 2.25 14.25H5.25C5.66421 14.25 6 13.9142 6 13.5V10.5C6 10.0858 5.66421 9.75 5.25 9.75Z"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5 3.75H15C14.5858 3.75 14.25 4.08579 14.25 4.5V9C14.25 9.41421 14.5858 9.75 15 9.75H19.5C19.9142 9.75 20.25 9.41421 20.25 9V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5 14.25H15C14.5858 14.25 14.25 14.5858 14.25 15V19.5C14.25 19.9142 14.5858 20.25 15 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V15C20.25 14.5858 19.9142 14.25 19.5 14.25Z"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 12H10.5"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.25 17.25H12C11.6022 17.25 11.2206 17.092 10.9393 16.8107C10.658 16.5294 10.5 16.1478 10.5 15.75V8.25C10.5 7.85218 10.658 7.47064 10.9393 7.18934C11.2206 6.90804 11.6022 6.75 12 6.75H14.25"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_220_1004">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),

    DepartmentIcon: () => (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_220_1027)">
          <path
            d="M21.6 20.5491C21.6838 20.6605 21.735 20.7931 21.7476 20.9319C21.7603 21.0708 21.734 21.2105 21.6716 21.3352C21.6093 21.4599 21.5134 21.5648 21.3948 21.6381C21.2762 21.7114 21.1394 21.7501 21 21.75H3C2.86072 21.75 2.72418 21.7112 2.6057 21.638C2.48722 21.5648 2.39147 21.46 2.32918 21.3354C2.26689 21.2108 2.24052 21.0714 2.25303 20.9326C2.26554 20.7939 2.31643 20.6614 2.4 20.55C3.06411 19.6596 3.94971 18.9586 4.96875 18.5166C4.41017 18.0068 4.01878 17.34 3.84595 16.6037C3.67313 15.8675 3.72695 15.0962 4.00034 14.3911C4.27374 13.686 4.75394 13.08 5.37791 12.6527C6.00188 12.2254 6.74046 11.9968 7.49672 11.9968C8.25297 11.9968 8.99156 12.2254 9.61553 12.6527C10.2395 13.08 10.7197 13.686 10.9931 14.3911C11.2665 15.0962 11.3203 15.8675 11.1475 16.6037C10.9747 17.34 10.5833 18.0068 10.0247 18.5166C10.7599 18.8344 11.428 19.289 11.9934 19.8563C12.5589 19.289 13.227 18.8344 13.9622 18.5166C13.4036 18.0068 13.0122 17.34 12.8394 16.6037C12.6666 15.8675 12.7204 15.0962 12.9938 14.3911C13.2672 13.686 13.7474 13.08 14.3713 12.6527C14.9953 12.2254 15.7339 11.9968 16.4902 11.9968C17.2464 11.9968 17.985 12.2254 18.609 12.6527C19.2329 13.08 19.7131 13.686 19.9865 14.3911C20.2599 15.0962 20.3137 15.8675 20.1409 16.6037C19.9681 17.34 19.5767 18.0068 19.0181 18.5166C20.0419 18.9562 20.9322 19.6571 21.6 20.5491ZM2.55 11.85C2.62879 11.9091 2.71845 11.9521 2.81386 11.9765C2.90927 12.001 3.00856 12.0064 3.10607 11.9925C3.20357 11.9785 3.29737 11.9455 3.38212 11.8954C3.46687 11.8452 3.54091 11.7788 3.6 11.7C4.05409 11.0945 4.64291 10.6031 5.31983 10.2647C5.99675 9.92621 6.74318 9.75 7.5 9.75C8.25682 9.75 9.00325 9.92621 9.68017 10.2647C10.3571 10.6031 10.9459 11.0945 11.4 11.7C11.4699 11.7931 11.5604 11.8688 11.6646 11.9208C11.7687 11.9729 11.8836 12 12 12C12.1164 12 12.2313 11.9729 12.3354 11.9208C12.4396 11.8688 12.5301 11.7931 12.6 11.7C13.0541 11.0945 13.6429 10.6031 14.3198 10.2647C14.9968 9.92621 15.7432 9.75 16.5 9.75C17.2568 9.75 18.0032 9.92621 18.6802 10.2647C19.3571 10.6031 19.9459 11.0945 20.4 11.7C20.4592 11.7788 20.5333 11.8452 20.6181 11.8953C20.7029 11.9455 20.7967 11.9784 20.8943 11.9923C20.9918 12.0062 21.0911 12.0007 21.1866 11.9762C21.282 11.9517 21.3717 11.9087 21.4505 11.8495C21.5293 11.7904 21.5956 11.7163 21.6458 11.6315C21.6959 11.5467 21.7289 11.4528 21.7428 11.3553C21.7567 11.2577 21.7512 11.1584 21.7267 11.063C21.7022 10.9675 21.6592 10.8779 21.6 10.7991C20.9359 9.90894 20.0503 9.2082 19.0312 8.76657C19.5898 8.25675 19.9812 7.58997 20.154 6.85372C20.3269 6.11748 20.2731 5.34619 19.9997 4.64108C19.7263 3.93597 19.2461 3.33 18.6221 2.9027C17.9981 2.4754 17.2595 2.24675 16.5033 2.24675C15.747 2.24675 15.0084 2.4754 14.3845 2.9027C13.7605 3.33 13.2803 3.93597 13.0069 4.64108C12.7335 5.34619 12.6797 6.11748 12.8525 6.85372C13.0253 7.58997 13.4167 8.25675 13.9753 8.76657C13.2401 9.08435 12.572 9.53898 12.0066 10.1063C11.4411 9.53898 10.773 9.08435 10.0378 8.76657C10.5964 8.25675 10.9878 7.58997 11.1606 6.85372C11.3334 6.11748 11.2796 5.34619 11.0062 4.64108C10.7328 3.93597 10.2526 3.33 9.62866 2.9027C9.00468 2.4754 8.2661 2.24675 7.50984 2.24675C6.75359 2.24675 6.015 2.4754 5.39103 2.9027C4.76706 3.33 4.28686 3.93597 4.01347 4.64108C3.74007 5.34619 3.68625 6.11748 3.85908 6.85372C4.0319 7.58997 4.42329 8.25675 4.98188 8.76657C3.95805 9.20662 3.06774 9.90782 2.4 10.8C2.34091 10.8788 2.29791 10.9685 2.27347 11.0639C2.24902 11.1593 2.24361 11.2586 2.25754 11.3561C2.27147 11.4536 2.30446 11.5474 2.35464 11.6321C2.40483 11.7169 2.47121 11.7909 2.55 11.85Z"
            fill="#FFA710"
          />
        </g>
        <defs>
          <clipPath id="clip0_220_1027">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),

    FunderIcon: () => (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_220_1014)">
          <path
            d="M16.9926 5.51529H7.99255C6.3357 5.51529 4.99255 6.85843 4.99255 8.51529V19.0153C4.99255 20.6721 6.3357 22.0153 7.99255 22.0153H16.9926C18.6494 22.0153 19.9926 20.6721 19.9926 19.0153V8.51529C19.9926 6.85843 18.6494 5.51529 16.9926 5.51529Z"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.99255 5.51529V3.26529C7.99255 3.06638 8.07157 2.87561 8.21222 2.73496C8.35288 2.59431 8.54364 2.51529 8.74255 2.51529H16.2426C16.4415 2.51529 16.6322 2.59431 16.7729 2.73496C16.9135 2.87561 16.9926 3.06638 16.9926 3.26529V5.51529"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9926 5.51529V2.51529"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.9926 5.51529V2.51529"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9926 16.7653H13.2426C13.6404 16.7653 14.0219 16.6073 14.3032 16.3259C14.5845 16.0446 14.7426 15.6631 14.7426 15.2653C14.7426 14.8675 14.5845 14.4859 14.3032 14.2046C14.0219 13.9233 13.6404 13.7653 13.2426 13.7653H11.7426C11.3447 13.7653 10.9632 13.6073 10.6819 13.3259C10.4006 13.0446 10.2426 12.6631 10.2426 12.2653C10.2426 11.8675 10.4006 11.4859 10.6819 11.2046C10.9632 10.9233 11.3447 10.7653 11.7426 10.7653H13.9926"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.4926 10.7653V9.26529"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.4926 18.2653V16.7653"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_220_1014">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.492554 0.265289)"
            />
          </clipPath>
        </defs>
      </svg>
    ),

    OperatorIcon: () => (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_220_1031)">
          <path
            d="M19.5801 6.89893C20.4085 6.89893 21.0801 6.22735 21.0801 5.39893C21.0801 4.5705 20.4085 3.89893 19.5801 3.89893C18.7517 3.89893 18.0801 4.5705 18.0801 5.39893C18.0801 6.22735 18.7517 6.89893 19.5801 6.89893Z"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5801 3.89893V2.77393"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.2807 4.64893L17.3066 4.08643"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.2807 6.14893L17.3066 6.71143"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5801 6.89893V8.02393"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.8794 6.14893L21.8535 6.71143"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.8794 4.64893L21.8535 4.08643"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.8301 15.1489C14.9011 15.1489 16.5801 13.47 16.5801 11.3989C16.5801 9.32786 14.9011 7.64893 12.8301 7.64893C10.759 7.64893 9.08008 9.32786 9.08008 11.3989C9.08008 13.47 10.759 15.1489 12.8301 15.1489Z"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.81128 18.8399C7.37557 17.7284 8.23662 16.7949 9.29897 16.1428C10.3613 15.4907 11.5835 15.1455 12.83 15.1455C14.0765 15.1455 15.2987 15.4907 16.3611 16.1428C17.4234 16.7949 18.2845 17.7284 18.8488 18.8399"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.7054 10.6489C22.0218 12.5289 21.7325 14.4609 20.8793 16.1658C20.0262 17.8706 18.6532 19.2603 16.9588 20.134C15.2643 21.0077 13.336 21.3202 11.4523 21.0266C9.56863 20.7329 7.82701 19.8481 6.47895 18.5001C5.13088 17.152 4.24613 15.4104 3.95244 13.5267C3.65876 11.643 3.97133 9.7147 4.84504 8.02024C5.71874 6.32578 7.10836 4.95284 8.81325 4.09966C10.5181 3.24648 12.4501 2.95721 14.3301 3.27362"
            stroke={mainBackground}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_220_1031">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.830078 0.148926)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
};

export default icons;
